import type { TFunction } from 'i18next';
import type { IScheduleProfession } from '@interfaces/IScheduler';
import { tradeLabel } from '@utils/tradeLabel';

/** A profession's words, as the pill writes them: its trade, then its
 *  specialty. Also what a 黒板 records as the work type. */
export function professionLabel(t: TFunction, profession: IScheduleProfession): string {
  const trade = tradeLabel(t, profession.tradeId) || profession.tradeGroup || '';
  return profession.specialty ? `${trade}, ${profession.specialty}` : trade;
}
